export const checkRes = {
  success: "success",
  failed: "failed",
};

export const splitTag = "，";

// 特定列
export const specRow = {
  idIdx: 1, // 匯入表格第一列
  labelIdx: 2, // 匯入表格第二列
  startRow: 4, // 匯入表格第四列
};
